import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../../../utils/style';
import { identity, middle } from '../../../../../utils/sizes';
import { TRANSPARENT } from '../../../../../utils/colors';

export const defaultContext = makeDefaultStylingContext();

const colors = {
  backgroundFocused: makeThemeColor(PRIMARY, 0.3),
  backgroundSelected: makeThemeColor(PRIMARY, 0.8),
  backgroundFocusedSelected: makeThemeColor(PRIMARY, 0.9),
  text: makeThemeColor(PRIMARY),
  textSelected: makeThemeColor(TERTIARY),
};

export const PADDING = 12;

export const getBasicFont = screenSize => getFont(FONT.OTTAWA_2, screenSize);

export const getFocusedSelectedFont = screenSize => getFont(FONT.OTTAWA_3, screenSize);

export const getInitialStyle = ({ colorMode, screenSize } = defaultContext) => {
  const font = getBasicFont(screenSize);
  const h = Math.max(font.lineHeight + PADDING * 2, 40);

  return {
    w: identity,
    h,
    Background: {
      w: identity,
      h,
      color: TRANSPARENT,
      shader: {
        radius: 8,
      },
    },
    Title: {
      color: colors.text[colorMode],
      x: middle,
      y: middle,
      mount: 0.5,
      text: {
        ...font,
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...',
      },
    },
  };
};

export const getUnFocusedStyle = ({ screenSize, colorMode }, selected) => {
  const font = selected ? getFocusedSelectedFont(screenSize) : getBasicFont(screenSize);

  return {
    Background: {
      smooth: {
        color: selected ? colors.backgroundSelected[colorMode] : TRANSPARENT,
      },
    },
    Title: {
      smooth: {
        color: selected ? colors.textSelected[colorMode] : colors.text[colorMode],
      },
      text: { ...font },
    },
  };
};

export const getFocusedStyle = ({ screenSize, colorMode }, selected) => {
  const font = selected ? getFocusedSelectedFont(screenSize) : getBasicFont(screenSize);

  return {
    Background: {
      smooth: {
        color: selected ? colors.backgroundFocusedSelected[colorMode] : colors.backgroundFocused[colorMode],
      },
    },
    Title: {
      smooth: {
        color: selected ? colors.textSelected[colorMode] : colors.text[colorMode],
      },
      text: { ...font },
    },
  };
};
